export const hasTextInError = (error?: boolean | string) => !(!error || error === true)
